<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center class="heading" v-if="init_load">
      <h3>Question Allocation</h3>
      {{cay}} | {{csem}}
      <br />
      <!-- {{exam_list}} -->
      <!-- Prog{{prog_list}} -->
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="6" sm="12" lg="6" md="6">
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <v-autocomplete
                  dense
                  v-if="exam_list.length!=0"
                  v-model="cexam"
                  :items="exam_list"
                  item-text="name"
                  label="Exam"
                  persistent-hint
                  :hint="cexam==null?'Please select exam':'Exam'"
                  return-object
                  single-line
                ></v-autocomplete>
               
              </v-col>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <v-autocomplete
                  dense
                  v-if="prog_type_list.length!=0"
                  v-model="cprog_type"
                  :items="prog_type_list"
                  item-text="name"
                  label="Program Type"
                  persistent-hint
                  :hint="cprog_type==null?'Please select program type':'Program Type'"
                  return-object
                  single-line
                ></v-autocomplete>
              </v-col>
              <v-col v-if="cprog_type!=null" cols="12" xs="12" sm="12" lg="12" md="12">
                <v-autocomplete
                  dense
                  v-model="cprog"
                  :items="progFilter"
                  item-text="prog_name"
                  label="Program"
                  persistent-hint
                  :hint="cprog==null?'Please select program':'Program'"
                  return-object
                  single-line
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <v-autocomplete
                  dense
                  v-if="year_list.length!=0"
                  v-model="cyear"
                  :items="year_list"
                  item-text="name"
                  label="Year"
                  persistent-hint
                  :hint="cyear==null?'Please select year':'Year'"
                  return-object
                  single-line
                ></v-autocomplete>
              </v-col>
            </v-col>
            <v-col cols="12" xs="6" sm="12" lg="6" md="6" v-if="cexam!=null">
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                Exam :
                <b>{{cexam.name}}</b>
              </v-col>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                Exam Status :
                <b>{{cexam.examstatus}}</b>
              </v-col>
                            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                              <span>Units No :</span><span v-for="(data,index) in unit_info" :key="index">
[{{data}}]

                              </span>

               
              </v-col>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                Exam Schedule :
                <b>{{cexam.startdate}} to {{cexam.enddate}}</b>
              </v-col>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                Exam Type :
                <b>{{cexam.examtype}}</b>
              </v-col>
              <v-col v-if="cexam!=null" cols="12" xs="12" sm="12" lg="12" md="12">
               <v-btn color="info" :loading="load_allocate" @click="examAlloStatus">'{{cexam.name}}' allocation status</v-btn>
               <br><span style="opacity:0.5;"> Question allocation status of all courses releated to exam '{{cexam.name}}'</span>
              </v-col>
            </v-col>
          </v-row>
          <v-btn color="warning" :loading="load_allocate" @click="allocate('ALLOCATION')">Allocate</v-btn>
          <v-btn color="info" :loading="load_allocate" @click="allocate('STATUS')">Get Allocation Status</v-btn>
        </v-card-text>
      </v-card>
    </center>
     <span style="opacity:0.5;" v-if="allocation_status==null && course_allocation==null">
       <br>
        <b>Allocate:</b> Question allocation of all courses filtered by above selections (exam, program type etc...). <i>This operation may take time depending on no of students and questions to be allocated.</i><br>
        <b>Get Allocation Status:</b> Question allocation status of all courses filtered by above selections (exam, program type etc...). <i>This operation may take time depending on no of students.</i><br>
        <i>It's better to check status before allocation.</i>
      </span>
    <template v-if="allocation_status!=null">
      <br>
        <center><h3>Status </h3></center>
              <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">SrNo</th>
              <th class="text-left">Course</th>
              <th class="text-left">Total Students</th>
              <th class="text-left">Ques-bank# </th>
              <th class="text-left">Excepted Ques#</th>
              <th class="text-left">Allocated#</th>
              <th class="text-left">In-complete Allocation#</th>
              <th class="text-left">No Allocation#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in allocation_status" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ item.course }}</td>
              <td>{{ item.stud_cnt }}</td>
              <td>{{ item.ques_in_bank }}</td>
              <td>{{ item.expected_total_ques_as_per_template }}</td>
              <td>{{ item.allocation_done }}</td>
              <td>{{ item.incomplete_allocation }}</td>
              <td>{{ item.no_allocation }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template v-if="course_allocation!=null">
      <br>
      <center><h3>Allocation status </h3></center>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">SrNo</th>
              <th class="text-left">Course</th>
              <th class="text-left">Status</th>
              <th class="text-left">Remark</th>
              <th class="text-left">Allocation#</th>
              <th class="text-left">Re-Allocation#</th>
              <th class="text-left">Already allocated#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in course_allocation" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ item.course }}</td>
              <td>{{ item.allocation_status }}</td>
              <td>{{ item.msg }}</td>
              <td>{{ item.stud_allo_cnt }}</td>
              <td>{{ item.stud_arello_cnt }}</td>
              <td>{{ item.stud_skip_cnt }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    
  </div>
</template>


<script>
import axios from "axios";
export default {
  data: () => ({
    init_load: false,
    load_allocate: false,
    load_allocate: false,
    //
    snackbar_msg: "",
    color: "",
    snackbar: false,
    ///
    cay: null,
    csem: null,
    exam_list: [],
    prog_type_list: [],
    prog_list: [],
    year_list: [],
    cprog: null,
    cprog_type: null,
    cexam: null,
    unit_info:[],
    cyear: null,
    //
    course_allocation: null,
    allocation_status: null,

  }),
  computed: {
    progFilter() {
      return this.prog_list.filter(
        (item) => item.pt_id === this.cprog_type.ptid
      );
    },
  },
  mounted() {
    this.init_load = false;
    axios
      .post("COEQuestionAllocation/init")
      .then((res) => {
        this.cay = res.data.cay;
        this.csem = res.data.csem;
        if (res.data.flag == "YES") {
          this.exam_list = res.data.exam_list;
          this.prog_type_list = res.data.prog_type_list;
          this.prog_list = res.data.prog_list;
          this.year_list = res.data.year_list;
          this.unit_info = res.data.unit_info;
        } else {
          this.showSnackbar("red", res.data.snackbar);
        }
        this.init_load = true;
      })
      .catch((error) => {
        //window.console.log(error);
        this.showSnackbar("red", "Something went wrong!!!");
      })
      .finally(() => {});
  },

  methods: {
    // fetch() {
    //   if (!this.allowproceed()) {
    //     return;
    //   }
    // },
    examAlloStatus(){
      this.allocation_status = null
      this.course_allocation = null
      this.load_allocate = true;
      axios
        .post("COEQuestionAllocation/examAllocation",{examid: this.cexam.examid,} )
        .then((res) => {
          if (res.data.flag == "YES") {
            this.allocation_status = res.data.course_allocation;
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          //window.console.log(error);
          this.showSnackbar("red", "Something went wrong!!!");
        })
        .finally(() => {
          this.load_allocate = false;
        });
    },
    allocate(type) {
      if (!this.allowproceed()) {
        return;
      }

      this.allocation_status = null
      this.course_allocation = null

      const formData = {
        progid: this.cprog.progid,
        ptid: this.cprog_type.ptid,
        yrid: this.cyear.yearid,
        examid: this.cexam.examid,
      };
      this.load_allocate = true;
      let url = "COEQuestionAllocation/allocation"
      if(type=="ALLOCATION")
        url = "COEQuestionAllocation/allocation"
      else if(type=="STATUS")
        url = "COEQuestionAllocation/allocation_status"

      axios
        .post(url, formData)
        .then((res) => {
          
          if (res.data.flag == "YES") {
            // if(res.data.course_allocation.length==0){
            //   this.showSnackbar("red", res.data.snackbar);
            // }
            if(type=="ALLOCATION"){
              this.course_allocation = res.data.course_allocation;
            }
            else{
              this.allocation_status = res.data.course_allocation;
            }
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          //window.console.log(error);
          this.showSnackbar("red", "Something went wrong!!!");
        })
        .finally(() => {
          this.load_allocate = false;
        });
    },
    allowproceed() {
      if (this.cexam == null) {
        this.showSnackbar("red", "Please Select Exam");
        return false;
      } else if (this.cprog_type == null) {
        this.showSnackbar("red", "Please Select Program Type");
        return false;
      } else if (this.cprog == null) {
        this.showSnackbar("red", "Please Select Program");
        return false;
      } else if (this.cyear == null) {
        this.showSnackbar("red", "Please Select Year");
        return false;
      }
      return true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>